//
import Model from "@/models/Model"

/**
 * @class
 */
export default class AReject extends Model {
    
    /**
     * @description
     */
    resource () {
        return "reject"
    }
}